/**
 * The chart's periods as `PeriodCompareChart` takes them, `{start, length}` with `start` the current
 * period's first day, and resolved into days as its spec resolves them (ui-components
 * docs/period-compare-chart, "Resolving a selection"), which the package does not export.
 */
const DAY = 86400000;

export const addDays = (day, n) => new Date(Date.parse(`${day}T00:00:00Z`) + n * DAY).toISOString().slice(0, 10);

/** Calendar months, the day clamped to the end of the target month. */
const addMonths = (day, n) => {
    const date = new Date(`${day}T00:00:00Z`);
    const target = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + n, 1));
    const lastOfMonth = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate();
    target.setUTCDate(Math.min(date.getUTCDate(), lastOfMonth));
    return target.toISOString().slice(0, 10);
};

/** The days the periods open on either side of an issue start: the days its loss is read over (traffic-lost.md). */
export const OPENING_LENGTH = { unit: "day", n: 30 };

/** The periods as the page opens: the current one starting on the issue start, or, without one, the last 30 days of the chart. */
export const openingSelectionOf = (since, lastDay) => ({ start: since ?? addDays(lastDay, 1 - OPENING_LENGTH.n), length: OPENING_LENGTH });

/** The previous and the current period's first and last days. */
export const periodsOf = ({ start, length }) => {
    if (length.unit === "month") {
        return {
            previous: { start: addMonths(start, -length.n), end: addDays(start, -1) },
            current: { start, end: addMonths(start, length.n) },
        };
    }
    const n = length.unit === "week" ? length.n * 7 : length.n;
    return {
        previous: { start: addDays(start, -n), end: addDays(start, -1) },
        current: { start, end: addDays(start, n - 1) },
    };
};

/** The span the zoom shows, widened where needed to cover both periods of `selection`. */
export const chartOf = (span, selection) => {
    const { previous, current } = periodsOf(selection);
    return {
        start: previous.start < span.start ? previous.start : span.start,
        end: current.end > span.end ? current.end : span.end,
    };
};
